/* eslint-disable import/first,import/newline-after-import */
import '../static/vendor/valiant360/valiant360.css'

import Bowser from 'bowser'
const browser = Bowser.getParser(window.navigator.userAgent)
window['browser'] = browser
export { browser }

import 'stacktrace-js'
import Flow from '@flowjs/flow.js'

window['Flow'] = Flow

import type _Dygraph from 'dygraphs'
export type Dygraph = _Dygraph

export async function loadDygraph (): Promise<(typeof _Dygraph) & {
  smoothPlotter: any
  synchronize: (_: Dygraph[]) => void
}> {
  const lib = await import(/* webpackChunkName: "dygraph" */ 'dygraphs/src/dygraph')
  window['Dygraph'] = lib.default
  await Promise.all([
    import(/* webpackChunkName: "dygraph" */ 'dygraphs/src/extras/smooth-plotter'),
    import(/* webpackChunkName: "dygraph" */ 'dygraphs/src/extras/synchronizer'),
  ])
  return lib.default
}

import type * as _three from 'three'
import type { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import type { FBXLoader } from 'three/examples/jsm/loaders/FBXLoader.js'
import type { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader.js'
import type { STLLoader } from 'three/examples/jsm/loaders/STLLoader.js'

export function loadThree (): Promise<typeof _three & {
  FBXLoader: typeof FBXLoader
  STLLoader: typeof STLLoader
  OBJLoader: typeof OBJLoader
  OrbitControls: typeof OrbitControls
}> {
  return Promise.all([
    import(/* webpackChunkName: "threejs" */ 'three/build/three.module.js'),
    import(/* webpackChunkName: "threejs" */ 'three/examples/jsm/loaders/FBXLoader.js'),
    import(/* webpackChunkName: "threejs" */ 'three/examples/jsm/loaders/STLLoader.js'),
    import(/* webpackChunkName: "threejs" */ 'three/examples/jsm/loaders/OBJLoader.js'),
    import(/* webpackChunkName: "threejs" */ 'three/examples/jsm/controls/OrbitControls.js'),
    // import(/* webpackChunkName: "threejs" */ 'zlibjs/bin/inflate.min'),
  ]).then(([
    three,
    { FBXLoader },
    { STLLoader },
    { OBJLoader },
    { OrbitControls },
    // zlibInflate,
  ]) => {
    // window.Zlib = zlibInflate.Zlib
    return {
      ...three,
      FBXLoader,
      STLLoader,
      OBJLoader,
      OrbitControls,
    }
  })
}

export function loadValiant () {
  return import(
    /* webpackChunkName: "valiant360" */
    '../static/vendor/valiant360/jquery.valiant360'
  )
}

import type * as MCAPITypes from '../static/vendor/MCAPI_Types'
import type { MCAPIClientImpl, GrpcWebImpl } from '../static/vendor/MCAPI'
export type MCAPIClient = MCAPIClientImpl
export type GrpcWeb = GrpcWebImpl
export type { MCAPITypes }

export async function loadMCAPI (): Promise<{
  MCAPITypes: typeof MCAPITypes
  MCAPIClient: typeof MCAPIClientImpl
  GrpcWeb: typeof GrpcWebImpl
}> {
  return Promise.all([
    import(/* webpackChunkName: "mcapi" */ '../static/vendor/MCAPI_Types'),
    import(/* webpackChunkName: "mcapi" */ '../static/vendor/MCAPI'),
  ]).then(([MCAPITypes, MCAPI]) => {
    return {
      MCAPITypes: MCAPITypes,
      MCAPIClient: MCAPI.MCAPIClientImpl,
      GrpcWeb: MCAPI.GrpcWebImpl,
    }
  })
}

import 'console-polyfill'
import 'fullscreen-api-polyfill'
